import PropTypes from "prop-types";
import { useClientContext } from "../../ClientContext.jsx";
import { Card, STitle, Badge } from "../adminUtils.jsx";

export default function UploadHistorySection({ uploads }) {
  const { T } = useClientContext();

  return (
    <Card T={T}>
      <STitle title="Histórico de Importações" T={T} />
      {uploads.length === 0 ? (
        <div style={{ textAlign: "center", padding: "30px 0", color: T.sub, fontSize: 13 }}>
          Nenhuma importação realizada nesta sessão.
        </div>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr>
              {["Data", "Cliente", "Fonte", "Arquivo", "Período", "Patrimônio", "Status"].map(
                (h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "8px 12px",
                      borderBottom: `2px solid ${T.border}`,
                      color: T.sub,
                      fontSize: 11,
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    {h}
                  </th>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {uploads.map((u, i) => (
              <tr key={u.id} style={{ background: i % 2 === 0 ? T.row1 : T.row2 }}>
                <td style={{ padding: "9px 12px", color: T.sub, fontSize: 12 }}>{u.date}</td>
                <td style={{ padding: "9px 12px", fontWeight: 600, color: T.text }}>{u.client}</td>
                <td style={{ padding: "9px 12px" }}>
                  <Badge text={u.source} color={u.source === "XP" ? "#2563EB" : "#7C3AED"} />
                </td>
                <td style={{ padding: "9px 12px", color: T.text, fontSize: 11 }}>📄 {u.file}</td>
                <td style={{ padding: "9px 12px" }}>
                  <Badge text={u.period} color={T.info || "#2563EB"} />
                </td>
                <td style={{ padding: "9px 12px", color: T.text, fontSize: 12 }}>
                  {u.patrimonio
                    ? `R$ ${u.patrimonio.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`
                    : "–"}
                </td>
                <td style={{ padding: "9px 12px" }}>
                  <Badge text={`✓ ${u.status}`} color="#16A34A" bg="#DCFCE7" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Card>
  );
}

UploadHistorySection.propTypes = {
  uploads: PropTypes.array.isRequired,
};
